import { useCopyToClipboard } from '@uidotdev/usehooks';
import { memo, useCallback, useState } from 'react';

import { merge } from '@/components';
import { Button, Text, TextProps } from '@/components/core';
import { CopyIcon } from '@/components/icons';

export type CopyTextProps = Omit<TextProps, 'children'> & {
  value?: string | null;
  isSensitive?: boolean;
};

const ICopyText = ({ value, isSensitive, className }: CopyTextProps) => {
  const [copiedText, copyToClipboard] = useCopyToClipboard();
  const [counter, setCounter] = useState(0);

  const copyText = useCallback(async () => {
    if (value) {
      copyToClipboard(value);
      setCounter((counter) => counter + 1);
    }
  }, [copyToClipboard, value]);

  const [show, setShow] = useState(false);
  const toggleShow = useCallback(() => setShow((s) => !s), []);
  const sensitiveValue = '*'.repeat(16);

  return (
    <div
      className={merge(
        'py-xs ps-sm flex items-center gap-2 rounded-lg border-1 border-gray-200 bg-gray-50 shadow-xs',
        className
      )}
    >
      <Text className="mp-mask truncate">{!isSensitive || show ? value : sensitiveValue}</Text>

      {isSensitive ? (
        <Button className="px-1 py-0.5" variant="secondary" onPress={toggleShow}>
          <Text size="xs">{show ? 'hide' : 'show'}</Text>
        </Button>
      ) : null}

      <div className="grow" />

      {copiedText ? (
        <Text key={counter} className="animate-fade opacity-0">
          Copied!
        </Text>
      ) : null}
      <Button isDisabled={!value} variant="plain" onPress={copyText}>
        <CopyIcon />
      </Button>
    </div>
  );
};

export const CopyText = memo(ICopyText) as typeof ICopyText;
